import {
  CLOSE_SET_IMPERSONATION_MODAL,
  OPEN_SET_IMPERSONATION_MODAL,
  SET_IMPERSONATION_ERROR,
  SET_IMPERSONATION_FORM_INITIAL_STATE,
  SET_IMPERSONATION_PENDING,
  SET_IMPERSONATION_SUCCESS,
} from './constants';

const INIT_STATE = {
  setImpersonationErrorMessages: null,
  setImpersonationStatus: '',
  isOpenSetImpersonationModal: false,
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case SET_IMPERSONATION_PENDING: {
      return {
        ...localState,
        setImpersonationStatus: 'PENDING',
      };
    }
    case SET_IMPERSONATION_SUCCESS: {
      return {
        ...localState,
        setImpersonationStatus: 'SUCCESS',
      };
    }
    case SET_IMPERSONATION_ERROR: {
      return {
        ...localState,
        setImpersonationStatus: 'ERROR',
        setImpersonationErrorMessages: action.payload,
      };
    }
    case SET_IMPERSONATION_FORM_INITIAL_STATE: {
      return {
        ...localState,
        setImpersonationStatus: '',
        setImpersonationErrorMessages: null,
      };
    }
    case OPEN_SET_IMPERSONATION_MODAL: {
      return {
        ...localState,
        isOpenSetImpersonationModal: true,
      };
    }
    case CLOSE_SET_IMPERSONATION_MODAL: {
      return {
        ...localState,
        isOpenSetImpersonationModal: false,
      };
    }
    default:
      return { ...localState };
  }
};
